import React, { FC } from 'react';
import MetaData from '@minecraft.meta-data';
import appConfig from 'config/appConfig';

type MetaProps = { pageTitle: string };

const Meta: FC<MetaProps> = ({ pageTitle }) => {
  const tabTitle = `${appConfig.companyName} ${pageTitle ? `- ${pageTitle}` : ''}`;

  return <MetaData title={tabTitle} />;
};

export default Meta;
